export const COUNTRIES = {
  venezuela: {
    pais: "venezuela",
    nombre: "Venezuela",
    marca: "Envíos hacia Venezuela",
    logoWhite: "/logo-white.png",
    logoColor: "/logo-color.png",
    casilleroPrefix: "PB",
    casilleroPlaceholder: "PB123456",
    flag: "🇻🇪",
    marquee: [
      "Miami → Venezuela",
      "Reempaque gratis",
      "Rastreo de paquetes",
      "Atención por correo",
      "Envíos garantizados",
    ],
  },
  nicaragua: {
    pais: "nicaragua",
    nombre: "Nicaragua",
    marca: "Envíos para Nicaragua",
    logoWhite: "/logo-nicaragua-white.png",
    logoColor: "/logo-nicaragua-color.png",
    casilleroPrefix: "NIC",
    casilleroPlaceholder: "NIC123456",
    flag: "🇳🇮",
    marquee: [
      "Miami → Nicaragua",
      "Reempaque gratis",
      "Rastreo de paquetes",
      "Atención por correo",
      "Envíos garantizados",
    ],
  },
};

export function detectCountry() {
  const host = (window.location.hostname || "").toLowerCase();
  const path = (window.location.pathname || "").toLowerCase();
  if (host.includes("nicaragua") || path.startsWith("/nicaragua")) {
    return "nicaragua";
  }
  return "venezuela";
}

export const COUNTRY_META = {
  venezuela: { flag: "🇻🇪", label: "Venezuela" },
  nicaragua: { flag: "🇳🇮", label: "Nicaragua" },
};
